<nav class="navbar bg-secondary navbar-dark navbar-expand-lg d-none d-lg-flex shadow">
  <a
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">Go To Home Page</label>
    <img alt="" class="logo-image h-100" aria-labelledby="homeLink" src="assets/images/logo.png" draggable="false" />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav mr-auto" #greedyNav>
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.payment'">
          <li class="nav-item active">
            <a class="nav-link mx-1" [routerLink]="['/payment']" routerLinkActive="router-link-active">
              {{ 'nav.payment' | translate }}
            </a>
          </li>
        </ng-container>

        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
          <ng-container *notInProductCode="productcode.Partner">
            <li class="nav-item active">
              <a class="nav-link mx-1" [routerLink]="['/partners']" routerLinkActive="router-link-active">
                {{ 'nav.partners' | translate }}
              </a>
            </li>
          </ng-container>
        </ng-container>

        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/faq']" routerLinkActive="router-link-active">
            {{ 'nav.faq' | translate }}
          </a>
        </li>

        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/terms']" routerLinkActive="router-link-active">
            {{ 'nav.terms' | translate }}
          </a>
        </li>
      </ul>
    </div>
    <!-- Right Side Content -->
    <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.payment'">
      <div class="balance text-white fw-bold d-flex align-items-center justify-content-end">
        <span class="icon material-icons currency-icons me-2">monetization_on</span>
        <span class="font-size-14"> {{ eCash$ | async | FortressCurrencyPipe }}</span>
      </div>
    </ng-container>

    <!--Notifications-->
    <fgb-notification-button></fgb-notification-button>
    <div class="form-inline my-2 my-lg-0">
      <div class="member" ngbDropdown #ddAccount="ngbDropdown" [autoClose]="'outside'" focusTab>
        <button
          class="nav-link btn d-flex align-items-center mx-2 ps-3 pe-1 justify-content-end text-white"
          id="namedropdown"
          ngbDropdownToggle
          attr.aria-label="{{ 'nav.account.dropdown.screenreader' | translate : { fgbdefault: 'Click for more account menu' } }}"
          tabindex="-1"
        >
          <div *ngIf="memberDetails$ | async as memberDetails; else memberDetailsLoading" class="user-box h-100 d-inline-block">
            <div class="font-size-14 text-start text-white">{{ memberDetails!.FirstName }}</div>
          </div>
        </button>

        <div
          ngbDropdownMenu
          (click)="closeDropDown(ddAccount)"
          aria-labelledby="namedropdown"
          class="shadow text-center border-0 dropdown-menu p-0 account-dropdown mt-2"
        >
          <div class="text-info">
            <a
              [routerLink]="['/account']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.account.screenreader' | translate : { fgbdefault: 'Move to account page' } }}"
              class="d-flex align-items-center account-btn text-black bg-white py-0 px-2 font-size-14 nav-item-fixed-height rounded-top"
              ngbDropdownItem
            >
              <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">person</span>
              <div class="dropdown-link text-start">
                <div class="mt-2 fw-bold">{{ 'nav.account' | translate }}</div>
                <ng-container *notInProductCode="productcode.Partner">
                  <div class="nav-bar-little-text text-start" *ngIf="card$ | async as memberCard">
                    {{ memberCard.ProductCode }} {{ 'product.code.description' | translate }}
                  </div>
                </ng-container>
              </div>
            </a>
          </div>

          <hr class="text-disabled w-90 my-0 mx-auto" />

          <div>
            <button
              class="logout-btn d-flex align-items-center bg-white px-2 nav-item-fixed-height rounded-bottom"
              (click)="logout()"
              ngbDropdownItem
              attr.aria-label="{{ 'nav.log.out.screenreader' | translate : { fgbdefault: 'Log out' } }}"
            >
              <span class="icon material-icons material-dropdown-icon me-2 text-black" aria-hidden="true"
                >power_settings_new</span
              >
              <div class="dropdown-link text-start">
                <div class="text-black py-1 font-size-14 fw-bold" ngbDropdownItem (click)="logout()">
                  {{ 'nav.log.out' | translate : { fgbdefault: 'Log out' } }}
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
